/** 超分提质工作流步骤：参数由后端固定，前端无可配置项 */
export default function ImageEnhanceStepParams() {
  return null;
}
